import { render, staticRenderFns } from "./HorizontalNavMenu.vue?vue&type=template&id=a3130d30"
import script from "./HorizontalNavMenu.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./HorizontalNavMenu.vue?vue&type=style&index=0&id=a3130d30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports